<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div>
  <div *ngIf="!password">
    <app-user-header header="Forgot Password"></app-user-header>
    <!-- <p *ngIf="invalidUser" class="error link">{{invalidUserMessage}}</p> -->
    <div>
      <p class="messagefont">{{ otp }}</p>
      <div fxLayout="row wrap" fxLayoutAlign="center center">
        <form [formGroup]="otpFormGroup">
          <div>
            <input
              formControlName="otpControl"
              type="{{ viewType }}"
              placeholder="Enter OTP"
              i18n-placeholder
              class="notranslate"
            /><br />
          </div>
          <p class="error" *ngIf="isErrorVerifyngOTP">{{ errorMessage }}</p>
          <app-submit-button
            buttontext="Verify OTP"
            (click)="otpValidation()"
          ></app-submit-button>
          <div class="bspacing"></div>
        </form>
      </div>
    </div>
  </div>
  <div *ngIf="password">
    <app-user-header header="Change Password"></app-user-header>
    <div fxLayout="row wrap" fxLayoutAlign="center center">
      <form [formGroup]="changePasswordForm">
        <div fxLayout="row" fxLayoutAlign="center center">
          <input
            fxFlex="90"
            formControlName="newPassword"
            type="password"
            placeholder="New Password"
            class="password notranslate"
            i18n-placeholder
            appShowHidePassword
          /><br />
        </div>
        <div
          *ngIf="
            newPassword.invalid && (newPassword.touched || newPassword.dirty)
          "
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          <small
            class="error notranslate"
            i18n
            *ngIf="newPassword.errors?.required"
            >Password is required
          </small>
          <small
            class="error notranslate"
            i18n
            *ngIf="newPassword.errors?.minlength"
            >Password must be at least 8 characters
          </small>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
          <input
            fxFlex="90"
            formControlName="confirmPassword"
            type="password"
            i18n-placeholder
            placeholder="Confirm new Password"
            class="password notranslate"
            appShowHidePassword
          /><br />
        </div>
        <div
          *ngIf="changePasswordForm.errors?.misMatch"
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          <small
            class="error notranslate"
            i18n
            *ngIf="changePasswordForm.errors?.misMatch"
            >Passwords do not match
          </small>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center">
          <p class="error" *ngIf="isErrorVerifyngOTP">{{ errorMessage }}</p>
        </div>
        <button
          (click)="passwordChange()"
          [disabled]="changePasswordForm.invalid"
          class="notranslate"
          i18n
        >
          SAVE CHANGES
        </button>
        <p class="success" *ngIf="successMessage">{{ successMessage }}</p>
        <div class="bspacing"></div>
      </form>
    </div>
  </div>
</div>
